import { render } from "./transferGtrPoints.vue?vue&type=template&id=60639be2&scoped=true&ts=true"
import script from "./transferGtrPoints.vue?vue&type=script&lang=ts"
export * from "./transferGtrPoints.vue?vue&type=script&lang=ts"

import "./transferGtrPoints.vue?vue&type=style&index=0&id=60639be2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60639be2"]])

export default __exports__